import { render, staticRenderFns } from "./InformasiPribadi.vue?vue&type=template&id=507691c2&scoped=true"
import script from "./InformasiPribadi.vue?vue&type=script&lang=js"
export * from "./InformasiPribadi.vue?vue&type=script&lang=js"
import style0 from "./InformasiPribadi.vue?vue&type=style&index=0&id=507691c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507691c2",
  null
  
)

export default component.exports